import updateInstanceReferences from '../../../../redux/utils/add/update-instance-references'
import setUtil from '../../../../../utils/set'

export default function updateOldAndNewInstanceReferences (params) {
  let {
    state,
    existingInstance,
    oldPath,
    instance
  } = params
  // Remove the old instance
  state = setUtil(state, oldPath, undefined)
  // Remove references from the old instance and make them point to the new one
  return updateInstanceReferences({
    state,
    instance,
    oldPath,
    existingInstance
  })
}
